import React from 'react';
import Education from './Education';

const QualificationSection = () => {
   return (
      <div>
         <div className="grid grid-cols-1 gap-3">
            <Education />
         </div>
      </div>
   );
};

export default QualificationSection;
